import sparksActions from '@/store/sparks/actions.js';
import sparksGetters from '@/store/sparks/getters.js';
import sparksMutations from '@/store/sparks/mutations.js';

export default {
  namespaced: true,
  state() {
    return {
      data: []
    };
  },
  actions: sparksActions,
  getters: sparksGetters,
  mutations: sparksMutations
};
